import React, { createContext, useState, useContext } from 'react';

// Create the context
const JobListRefreshContext = createContext();

// Custom Provider component
export const JobListRefreshProvider = ({ children }) => {
  //console.log(children );
  const [jobListRefresh, setJobListRefresh] = useState(false);

  const triggerJobListRefresh = () => {
    setJobListRefresh(prev => !prev);
  };

  return (
    <JobListRefreshContext.Provider value={{ jobListRefresh, triggerJobListRefresh }}>
      {children}
    </JobListRefreshContext.Provider>
  );
};

// Custom hook to use the context
export const useJobListRefreshContext = () => useContext(JobListRefreshContext);